import PropTypes from 'prop-types'

export const SHAPE_ROOM_DETAIL = PropTypes.shape({
  label: PropTypes.string,
  codes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired
  }))
})

export const SHAPE_ROOM = {
  id: PropTypes.string,
  giataId: PropTypes.number.isRequired,
  attributes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.any
    })
  ).isRequired,
  codes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      code: PropTypes.string
    })
  ).isRequired,
  details: PropTypes.arrayOf(SHAPE_ROOM_DETAIL).isRequired
}
